/**
* Custom React hook that returns a function to remove all gift card payment instruments
* (with paymentMethodId 'SMARTCLIXX') from the provided basket using the Salesforce Commerce SDK.
*
* @param {Object} basket - The current basket object containing payment instruments and basketId.
* @returns {Function} removeGiftCards - An async function that removes all applicable gift card payment instruments from the basket.
*/
import { useShopperBasketsMutation } from '@salesforce/commerce-sdk-react';

export const useRemoveGiftCards = (basket) => {
    const { mutateAsync: removePaymentInstrumentFromBasket } = useShopperBasketsMutation(
        'removePaymentInstrumentFromBasket'
    );

    const removeGiftCards = async () => {
        if (!basket) return;

        const giftCards = (basket.paymentInstruments || []).filter(
            (instrument) => instrument.paymentMethodId === 'SMARTCLIXX'
        );

        for (const giftCard of giftCards) {
            try {
                await removePaymentInstrumentFromBasket({
                    parameters: {
                        basketId: basket.basketId,
                        paymentInstrumentId: giftCard.paymentInstrumentId
                    }
                });
            } catch (error) {
                console.error('Error removing gift card:', error);
            }
        }
    };

    return removeGiftCards;
};
